// @ts-nocheck
import Page from "@insite/mobius/Page";
import { clearfixStyles, stretchStyles } from "@toolkit/Themes/common/mixins";
import merge from "lodash/merge";
import { css } from "styled-components";

merge(Page.defaultProps, {
    padding: 0,
    fullWidth: [true, true, true, true, true],
    css: css`
        overflow: visible !important; /* Required to override overflow media queries */
        ${clearfixStyles()}

        &:is(main) {
            ${stretchStyles()}
        }
    `,
});
